import { render, staticRenderFns } from "./IndustryPlateHolders.vue?vue&type=template&id=ccc27f58&scoped=true"
import script from "./IndustryPlateHolders.vue?vue&type=script&lang=js"
export * from "./IndustryPlateHolders.vue?vue&type=script&lang=js"
import style0 from "./IndustryPlateHolders.vue?vue&type=style&index=0&id=ccc27f58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccc27f58",
  null
  
)

export default component.exports